<template>
    <div
        :title="isClosed ? 'Se alle månedene' : 'Se bare år'"
        class="w-full flex justify-between py-2 hover:px-1 hover:bg-base-300 transition-all"
        :class="!isClosed ? 'bg-base-200/50 dark:bg-base-400 px-1 hover:px-2' : 'px-2'"
        @click="onColumnHeaderClicked"
    >
        <b>{{ props.params.displayName }}</b>
        <div class="text-lg">
            <i v-if="isClosed" title="Åpne" class="flex i-ph-arrows-out-line-horizontal"/>
            <i v-else title="Lukk" class="flex i-ph-arrows-in-line-horizontal"/>
        </div>
    </div>
</template>

<script setup lang="ts">

import {ColumnGroup, GridApi} from 'ag-grid-community'
import {computed} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            api: GridApi,
            columnGroup: ColumnGroup,
            displayName: string
        },
        required: true
    }
})

const onColumnHeaderClicked = () => {
    const nextVisibility = props.params.columnGroup.getProvidedColumnGroup().getLeafColumns().some(col => !col.isVisible())
    props.params.api.setColumnsVisible(props.params.columnGroup.getProvidedColumnGroup().getLeafColumns().filter(col => !col.getColId().includes('sum')), nextVisibility)
    props.params.api.refreshHeader()
}

const isClosed = computed(() => props.params?.columnGroup.getChildren()?.length === 1)

</script>


<style scoped>

</style>